import { render } from "./OapSlider.vue?vue&type=template&id=f1d2352e"
import script from "./OapSlider.vue?vue&type=script&lang=js"
export * from "./OapSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__